export default __webpack_public_path__ + "static/media/cny_2024-bm.fa33e2cc.webp";